<nav [ngClass]="Fixtop" class="py-3 backgroundTheme">
  <div>
    <div class="textoArriba">
      <div class="organizadorBaner" *ngIf="this.retroSelected">
        <div class="container">
          <div class="row">
            <div class="col divFlecha">
              <button (click)="this.regresarPagina()" style="border: 0px; background-color: transparent">
                <img class="tamano-2 img-responsive" src="./assets/img/Arrow_Big.png" alt="seguro de moto precio" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="textoAbajo">
      <div class="organizadorBaner" *ngIf="this.retroSelected">
        <div class="container">
          <div class="row">
            <div class="col divFlecha">
              <button (click)="this.regresarPagina()" style="border: 0px; background-color: transparent">
                <img class="tamano-2 img-responsive" src="./assets/img/Arrow_Big.png" alt="seguro de moto precio" />
              </button>
            </div>
            <div class="col-auto">
              <div>
                <button (click)="this.regresarPagina()" style="border: 0px; background-color: transparent; padding-left: 0px">
                  <p class="estiloFlechaBanner">Seguro voluntario para motos</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="img-container">
    <img
      name="logo"
      class="img-responsive"
      src="./assets/img/Capa_1-2.svg"
      width="122"
      height="42"
      loading="lazy"
      alt="Imagen Banner Sura"
    />
  </div>
</nav>

<div *ngIf="showBanner && showPromo">
  <app-anuncio></app-anuncio>
</div>
